import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-inline-edit',
    template: `
    @if (editing && allowEdit) {
      <div class="mr-3">
        <ng-content select="[editMode]"></ng-content>
      </div>
    }
    @if (!editing) {
      <ng-content select="[viewMode]"></ng-content>
    }
    `,
    standalone: false
})
export class InlineEditComponent implements OnChanges {
  @Input() allowEdit = true; // todo maybe we could pass in the form control and look at the disabledState state?
  @Input() editing = false;

  ngOnChanges(changes: SimpleChanges) {
    if (this.editing && !this.allowEdit) {
      this.editing = false;
    }
  }
}
